var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useState } from 'react';
import { Box, Card, Flex, Image, Tooltip, getPaletteColor } from 'pcln-design-system';
import { Dot } from 'pcln-icons';
import styled from 'styled-components';
var TRAVEL_BOT_LOGO = 'https://s1.pclncdn.com/design-assets/pcln-bot/logos/pcln_bot_opener_logo_no_border_v1.1.svg';
var CircleCard = styled(Card)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 60px;\n  height: 60px;\n  background-color: ", ";\n  transition: 0.2s ease-in-out;\n  border: none;\n  box-shadow: ", ";\n\n  &:hover {\n    cursor: pointer;\n    box-shadow: ", ";\n  }\n"], ["\n  width: 60px;\n  height: 60px;\n  background-color: ", ";\n  transition: 0.2s ease-in-out;\n  border: none;\n  box-shadow: ", ";\n\n  &:hover {\n    cursor: pointer;\n    box-shadow: ", ";\n  }\n"])), getPaletteColor('primary.base'), function (_a) {
    var theme = _a.theme;
    return theme.shadows.md;
}, function (_a) {
    var theme = _a.theme;
    return theme.shadows.lg;
});
var StyledDot = styled(Dot)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  right: -8px;\n  top: -5px;\n"], ["\n  position: absolute;\n  right: -8px;\n  top: -5px;\n"
    /**
     * StickyChatBotOpener Component
     * @public
     */
])));
/**
 * StickyChatBotOpener Component
 * @public
 */
export var StickyChatBotOpener = function (props) {
    var isChatBoxOpened = props.isChatBoxOpened, onComponentRendered = props.onComponentRendered, onClickHandler = props.onClickHandler, openerPosition = props.openerPosition;
    var _a = useState(false), isTooltipOpen = _a[0], setIsOpen = _a[1];
    var _b = useState(false), isSectionActive = _b[0], setIsSectionActive = _b[1];
    useEffect(function () {
        onComponentRendered();
    }, []);
    useEffect(function () {
        if (isChatBoxOpened && !isSectionActive) {
            setIsSectionActive(true);
        }
    }, [isChatBoxOpened]);
    function onMouseOver() {
        setIsOpen(true);
    }
    function onMouseOut() {
        setIsOpen(false);
    }
    var openerTooltipProps = props.openerTooltipProps || {};
    var tooltipProps = __assign({ top: true, center: true, bg: 'black', color: 'white' }, openerTooltipProps);
    return (React.createElement(CircleCard, { style: __assign({ position: 'fixed', right: '32px', bottom: '32px' }, openerPosition), borderRadius: 50, "data-testid": 'openChatBotDialog', onClick: onClickHandler, onMouseOver: onMouseOver, onMouseOut: onMouseOut },
        isTooltipOpen && (React.createElement(Tooltip, __assign({ p: 1, style: __assign({ bottom: '-2px' }, props.openerTooltipStyle) }, tooltipProps),
            React.createElement(Box, { width: '110px' }, "Chat with Penny"))),
        React.createElement(Flex, { alignItems: 'center' },
            React.createElement(Image, { src: TRAVEL_BOT_LOGO, width: 60, alt: 'Penny chat opener' })),
        isSectionActive && !isChatBoxOpened && React.createElement(StyledDot, { size: 32, color: 'warning.tone' })));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=StickyChatBotOpener.js.map